module.exports = __webpack_public_path__ + "static/media/user.c70fda0c.svg";